import { FC } from "react";
import { Modal, Table } from "antd";
import { OrderProcessingModel } from "states/order/order.models";
import { ColumnsType } from "antd/lib/table";
import momentTz from "moment-timezone";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "app.store";
import { momentDateTimeFormat } from "shared/plugins/localization";

interface IOrderProcessingModalProps {
  processings: OrderProcessingModel[];
  onModal: boolean;
  closeModal: () => void;
}
export const OrderProcessingModal: FC<IOrderProcessingModalProps> = (props) => {
  const { processings, onModal, closeModal } = props;
  const currentTimeZone = useSelector(
    (state: RootState) => state.globalValue.ianaTimeZone,
    shallowEqual
  );

  const columns: ColumnsType<OrderProcessingModel> = [
    {
      title: "Thời gian",
      dataIndex: "creationTime",
      key: "creationTime",
      render: (creationTime: string, item) => (
        <>
          {momentTz
            .tz(item.creationTime, currentTimeZone)
            .format(momentDateTimeFormat())}
        </>
      ),
    },
    {
      title: "Mô tả",
      dataIndex: "description",
      key: "description",
      render: (description: string, item) => <>{item.description}</>,
    },
    {
      title: "Người thực hiện",
      dataIndex: "paymentMethod",
      key: "paymentMethod",
      render: (paymentMethod: string, item) => <>{item.creator}</>,
    },
    {
      title: "IP Address",
      dataIndex: "ip",
      key: "ip",
      render: (ip: string, item) => <>{item.ipAddress}</>,
    },
  ];
  return (
    <Modal
      title="Lịch sử thao tác"
      cancelText="Đóng"
      okText="Ok"
      onOk={() => {
        closeModal();
      }}
      visible={onModal}
      onCancel={() => {
        closeModal();
      }}
      width={800}
    >
      <Table
        columns={columns}
        dataSource={processings}
        size="small"
        pagination={false}
      ></Table>
    </Modal>
  );
};
